class CVFutureAPI {
	getEmployeesById = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employer/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getEmployeeInformation = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employerinformations/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return await response.json()
	}

	getAssetsEmployee = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/assetsuploader/employee/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})
		return response.json()
	}

	getAreaList = async () => {
		const response = await fetch(`${process.env.REACT_APP_API}/search/area`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return await response.json()
	}

	getLevelList = async () => {
		const response = await fetch(`${process.env.REACT_APP_API}/search/level`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getEmployeesExp = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employersexp/exp/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getKnowledge = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/knowledge/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getPurposeByEmployeeId = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/purpose/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getCulture = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employercp/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	getEmployeePerformance = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employermedia/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getEmployerMotivationAssets = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/motivation/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getCompentences = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/motivation/resultMycoHabilities/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getMotivations = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/motivation/resultMycoMotivations/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getSalarySMTM = async employeeMail => {
		const data = await fetch(`https://smtm.co/v1/position_by_mydna_email?email=${employeeMail}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return data.json()
	}

	getSalary = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/${employeeId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	get360Profile = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/employermedia/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	getCareer = async employeeId => {
		const response = await fetch(`${process.env.REACT_APP_API}/career/employee/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}
}
export default new CVFutureAPI()
